import { useEffect } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import type { Result } from '@atlassian/jira-software-fast-virtual';

const EXTRA_BUFFER_BOTTOM_OF_VIEWPORT = 190;

export const useScrollToICC = (
	issueCount: number,
	shouldScrollToOpenICCForm: boolean | undefined,
	scrollTo: Result['scrollTo'],
	setShouldScrollToICC: ((shouldScroll: boolean) => void) | undefined,
) => {
	if (!fg('jsw_sticky_icc_large_kanban_boards_fg')) {
		return;
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	useEffect(() => {
		if (shouldScrollToOpenICCForm) {
			return scrollTo(issueCount, {
				immediate: true,
				onComplete: () => setShouldScrollToICC?.(false),
				bufferBottomOfViewport: EXTRA_BUFFER_BOTTOM_OF_VIEWPORT,
			});
		}
	}, [issueCount, scrollTo, setShouldScrollToICC, shouldScrollToOpenICCForm]);
};
